import React from "react";
import { Layout, Menu } from "antd";
import { Link, Outlet, useLocation } from "react-router-dom";
import { routes } from "../../routes";
import CustomFooter from "./CustomFooter";
import styles from "./BaseLayout.module.css";

const { Header, Content } = Layout;

const BaseLayout: React.FC = () => {
  const location = useLocation();

  const isHomePage = location.pathname === `${routes.HOME}`;

  const menuItems = [
    { key: `${routes.HOME}`, label: <Link to={`${routes.HOME}`}>Home</Link> },
    {
      key: `${routes.PROJECT}`,
      label: <Link to={`${routes.PROJECT}`}>Il Progetto</Link>,
    },
    {
      key: `malattie`,
      label: "Malattie d'interesse",
      children: [
        {
          label: (
            <Link to={`${routes.AMILOIDOSI_CARDIACA}`}>
              Amiloidosi cardiaca
            </Link>
          ),
          key: `${routes.AMILOIDOSI_CARDIACA}`,
        },
        {
          label: (
            <Link to={`${routes.MALATTIA_DI_FABRY}`}>Malattia di Fabry</Link>
          ),
          key: `${routes.MALATTIA_DI_FABRY}`,
        },
        {
          label: (
            <Link to={`${routes.CARDIOMIOPATIA_IPERTROFICA_OSTRUTTIVA}`}>
              Cardiomiopatia ipertrofica ostruttiva
            </Link>
          ),
          key: `${routes.CARDIOMIOPATIA_IPERTROFICA_OSTRUTTIVA}`,
        },
        {
          label: (
            <Link to={`${routes.IPERCOLESTEROLEMIA_FAMILIARE}`}>
              Ipercolesterolemia familiare
            </Link>
          ),
          key: `${routes.IPERCOLESTEROLEMIA_FAMILIARE}`,
        },
      ],
    },
    {
      key: `${routes.SYMPTOMS}`,
      label: <Link to={`${routes.SYMPTOMS}`}>Segni e sintomi suggestivi</Link>,
    },
    {
      key: `${routes.CONTACT}`,
      label: <Link to={`${routes.CONTACT}`}>Contatti</Link>,
    },
    {
      key: `${routes.LOGIN}`,
      label: <Link to={`${routes.LOGIN}`}>Area Riservata</Link>,
    },
    {
      key: `${routes.REGISTER}`,
      label: <Link to={`${routes.REGISTER}`}>Registrazione Medico</Link>,
    },
    {
      key: `${routes.PATIENT_CONTACT}`,
      label: (
        <Link to={`${routes.PATIENT_CONTACT}`}>Registrazione Paziente</Link>
      ),
    },
  ];

  return (
    <Layout className="layout">
      <Header style={{ display: "flex", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div className="logo" />
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            style={{ flex: 1, minWidth: 0, justifyContent: "flex-start" }}
          />
        </div>
      </Header>
      <Content
        className={!isHomePage ? styles.contentWithPadding : styles.content}
      >
        <Outlet />
      </Content>
      <CustomFooter />
    </Layout>
  );
};

export default BaseLayout;
